module.exports = "<div id=\"cot-overlay\" *ngIf=\"!isSpinnerHidden\">\r\n  <mat-spinner ngClass.lt-sm=\"cot-loader-mobile\" ngClass.gt-sm=\"cot-loader-desktop\"></mat-spinner>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/loading-spinner/loading-spinner.component.html
// module id = ./src/app/widgets/loading-spinner/loading-spinner.component.html
// module chunks = main